// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3L93_","title":"AfterFrontImage_title__2WEIy"};